import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import { selectTransactionAccounts } from '@debbie/cortex/dist/transaction-accounts/selectors.js';
const TransactionAccountPreview = (props) => {
    const transactionAccounts = useSelector(selectTransactionAccounts);
    useEffect(() => {
        if (!transactionAccounts) {
            c.transactionAccounts.getAll();
        }
    }, []);
    const transactionAccount = transactionAccounts?.find((_transactionAccount) => _transactionAccount.transactionAccountId === props.transactionAccountId);
    return React.createElement(React.Fragment, null, transactionAccount?.name);
};
export default TransactionAccountPreview;
//# sourceMappingURL=TransactionAccountPreview.js.map